import React from 'react';
import { useProcessInstanceId } from 'domain/gpo/cockpit/instance/processInstanceRoute';
import useProcessInstanceService from 'domain/gpo/cockpit/instance/processInstanceService';
import { DataGridLayout, RelatedList, RelationListLayout } from 'framework/list';
import { FullDateField, TextField } from 'framework/ui/field';
import ProcessInstanceLinkField from '../../shared/ProcessInstanceLinkField';
import IncidentCountField from '../../shared/IncidentCountField';
import ProcessDefinitionField from '../../shared/ProcessDefinitionField';
import ProcessStateField from '../../shared/ProcessStateField';

const Subprocesses = () => {
  const id = useProcessInstanceId();
  const { getSubprocesses } = useProcessInstanceService();

  const getDataMethod = async () => {
    const issues = await getSubprocesses(id);
    return issues;
  };

  return (
    <RelatedList getDataMethod={getDataMethod}>
      <RelationListLayout header="Subprocesses" actions={[]}>
        <DataGridLayout showTotal={false} buttons={[]} isSmallTable>
          <ProcessInstanceLinkField source="id" />
          <IncidentCountField source="incidentCount" label="Incidents" />
          <ProcessDefinitionField label="Process key / Version" keySource="processKey" versionSource="processVersion" />
          <TextField source="businessKey" label="Business key" />
          <ProcessStateField source="state" />
          <FullDateField source="startDateTime" label="Start date" isSortable />
          <FullDateField source="endDateTime" label="End date" isSortable />
        </DataGridLayout>
      </RelationListLayout>
    </RelatedList>
  );
};

export default Subprocesses;
